import React, { useCallback, useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import { groupBy } from 'lib/array/arrayUtils'
import MultipleRoomsBookingModalRoomDetails from './MultipleRoomsBookingModalRoomDetails'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

const RoomsContainer = styled(ModalContent)`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
`

interface Props {
  offer: App.Offer;
  title: string;
  subtitle: string;
  availablePackages: Array<OfferPackageOptionView>;
  selectedPackageOption?: OfferPackageOptionView;
  room: App.RoomOccupants;
  isFlightsSelected: boolean;
  isFlightsEnabled: boolean;
}

function MultipleRoomsBookingRoomsModal(props: Props) {
  const {
    offer,
    title,
    subtitle,
    availablePackages,
    selectedPackageOption,
    room,
    isFlightsSelected,
    isFlightsEnabled,
  } = props

  const modalElement = useModalElementContext<App.Package | undefined>()

  const onRoomSelect = useCallback((packageOption: App.Package) => {
    modalElement.resolve(packageOption)
  }, [modalElement])

  const closeModal = useCallback(() => {
    modalElement.resolve(undefined)
  }, [modalElement])

  const optionsByRoomType = useMemo(() => Array.from(groupBy(availablePackages, (pkg) => pkg.package.roomType.id).values()), [availablePackages])

  return (
    <ModalBase size="L">
      <ModalHeader
        title={title}
        subtitle={subtitle}
        onCloseButtonClick={closeModal}
      />
      <ModalBody>
        <RoomsContainer>
          {optionsByRoomType.map((packageOptions, index) => (
            <MultipleRoomsBookingModalRoomDetails
              key={index}
              room={room}
              offer={offer}
              packageViewOptions={packageOptions}
              selectedPackageUniqueKey={selectedPackageOption?.package.uniqueKey}
              onSelect={onRoomSelect}
              isFlightsSelected={isFlightsSelected}
              isFlightsEnabled={isFlightsEnabled}
              closeRoomsModal={closeModal}
            />
          ))}
        </RoomsContainer>
      </ModalBody>
    </ModalBase>
  )
}

export default withOfferPageAndReduxState((state) => ({
  offer: state.offer,
}), MultipleRoomsBookingRoomsModal)
